
    var riot = require('riot')
    //src: starling/src/tags/text-toolbar.html
riot.tag2('text-toolbar',
  '<button class="Button Button--Icon Button--Plain" onmousedown="{preventDefault}" onmouseup="{preventDefault}" onclick="{toggleSizeMenu}"> <svg class="Button__Icon"> <use xlink:href="#text-fields-icon"></use> </svg> <svg class="Button__Icon Button__Icon--Caret"> <use xlink:href="#arrow-drop-down-icon"></use> </svg> </button> <div ref="sizeMenu" class="floating-menu floating-menu--small floating-menu--top floating-menu--hidden"> <ul class="floating-menu_list"> <li class=" floating-menu_item floating-menu_item--{activeSize === \'normal\' ? \'active\' : \'iconless\'} " onmousedown="{setSize.bind(this, \'normal\')}"> <svg if="{activeSize === \'normal\'}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Normal</span> </li> <li class=" floating-menu_item floating-menu_item--{activeSize === \'large\' ? \'active\' : \'iconless\'} " onmousedown="{setSize.bind(this, \'large\')}"> <svg if="{activeSize === \'large\'}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Large</span> </li> <li class=" floating-menu_item floating-menu_item--{activeSize === \'huge\' ? \'active\' : \'iconless\'} " onmousedown="{setSize.bind(this, \'huge\')}"> <svg if="{activeSize === \'huge\'}" class="floating-menu_icon"> <use xlink:href="#check-icon"></use> </svg> <span class="floating-menu_label">Huge</span> </li> </ul> </div> <span class="text-toolbar_divider"></span> <button class="Button Button--Icon Button--Plain {\'Button--Active\': isBold}" data-tip="Bold" data-tip-align="top" onmousedown="{preventDefault}" onmouseup="{preventDefault}" onclick="{bold}"> <svg class="Button__Icon"> <use xlink:href="#format-bold-icon"></use> </svg> </button> <button class="Button Button--Icon Button--Plain {\'Button--Active\': isItalics}" data-tip="Italic" data-tip-align="top" onmousedown="{preventDefault}" onmouseup="{preventDefault}" onclick="{italics}"> <svg class="Button__Icon"> <use xlink:href="#format-italic-icon"></use> </svg> </button> <button class="Button Button--Icon Button--Plain {\'Button--Active\': isLink}" data-tip="{isLink ? \'Edit Link\' : \'Create Link\'}" data-tip-align="top" onmousedown="{preventDefault}" onmouseup="{preventDefault}" onclick="{editLink}"> <svg class="Button__Icon"> <use xlink:href="#format-link-icon"></use> </svg> </button> <span class="text-toolbar_divider"></span> <button class="Button Button--Icon Button--Plain" data-tip="Reset" data-tip-align="top" onmousedown="{preventDefault}" onmouseup="{preventDefault}" onclick="{reset}"> <svg class="Button__Icon"> <use xlink:href="#format-clear-icon"></use> </svg> </button>',
  '',
  'show="{summoned}" class="text-toolbar"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.positionSelf = _menuUi.mui.positionSelf.bind(this);
this.canvas = this.opts.canvas;
this.canvas.textToolbar = this;

this.summoned = false;
this.isBold = false;
this.isUnderline = false;
this.isItalics = false;
this.isLarge = false;
this.isLink = false;

function saveSelection() {
  if (window.getSelection) {
    var sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
  } else if (document.selection && document.selection.createRange) {
    return document.selection.createRange();
  }
  return null;
}

function restoreSelection(range) {
  if (range) {
    if (window.getSelection) {
      var sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (document.selection && range.select) {
      range.select();
    }
  }
}

this.summon = function (_ref) {
  var x = _ref.x,
      y = _ref.y;

  if (!_this.editableElement()) return;
  if (_this.canvas.isViewOnly()) return;

  _this.lastSelectionRange = saveSelection();

  _this.canvas.nodeTools.suppress();
  _this.positionSelf({
    selfEl: _this.root,
    clickPosition: { x: x, y: y }
  });

  _this.update({
    summoned: true
  });
};

this.hide = function () {
  _this.summoned = false;
  _this.toolbarUsed = false;
  _this.isBold = false;
  _this.isUnderline = false;
  _this.isItalics = false;
  _this.isLarge = false;
  _this.isLink = false;
  _this.closeSizeMenu();

  _this.update();
  _this.canvas.nodeTools.unsuppress();
};

this.selectAll = function (element) {
  var range = document.createRange();
  range.selectNodeContents(element);
  var selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
};

this.editableElement = function () {
  if (!document.getSelection().rangeCount) return null;
  var ancestor = document.getSelection().getRangeAt(0).commonAncestorContainer;
  var ancestorElement = ancestor.nodeType == 1 ? ancestor : ancestor.parentElement;
  var editableElement = ancestorElement.closest('.node_title.title, .summary');
  return editableElement;
};

this.setSize = function (textSize) {
  var selectAllAfterSetting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var editableElement = _this.editableElement();
  editableElement.innerHTML = editableElement.innerHTML.replace(/^<h[12]>(.*)<\/h[12]>$/, "$1");
  if (textSize == 'large') {
    editableElement.innerHTML = '<h2>' + editableElement.innerHTML + '</h2>';
  } else if (textSize == 'huge') {
    editableElement.innerHTML = '<h1>' + editableElement.innerHTML + '</h1>';
  }
  if (selectAllAfterSetting) _this.selectAll(editableElement);
  _this.toolbarUsed = true;
  _this.toggle();
  _this.closeSizeMenu();
};
this.reset = function (e) {
  e.stopPropagation();
  document.execCommand('removeFormat');
  document.execCommand('unlink');
  _this.setSize('normal', false);
};
this.bold = function (e) {
  e.stopPropagation();
  var editableElement = _this.editableElement();
  // firefox thinks it's smart and won't let us bold medium weight text
  editableElement.classList.add("firefox-boldable");
  document.execCommand('bold');
  editableElement.classList.remove("firefox-boldable");
  _this.toolbarUsed = true;
  _this.toggle();
};

this.editLink = function (e) {
  e.stopPropagation();
  _this.lastSelectionRange = saveSelection();

  var selection = document.getSelection();
  var selectionLength = selection.toString().length;
  var range = selectionLength && selection.getRangeAt(0);

  var selectedNode = range.commonAncestorContainer;
  var selectedElement = selectedNode.nodeType == 1 ? selectedNode : selectedNode.parentElement;

  var containingATag = selectedElement.closest('[contenteditable] a');
  var aIndex = Array.from(_this.editableElement().querySelectorAll('a')).findIndex(function (a) {
    return a === containingATag;
  });

  var alreadyExistingUrl = '';
  if (containingATag) {
    range.selectNode(containingATag);
    alreadyExistingUrl = containingATag.getAttribute('href');

    var editableElement = _this.editableElement();
    canvas.externalLinkPopover.summon({
      editableElement: editableElement,
      aIndex: aIndex,
      anchorTag: containingATag,
      href: alreadyExistingUrl,
      isEditing: true,
      autoLinkified: containingATag.classList.contains('linkified')
    });
  } else {
    var _range$getBoundingCli = range.getBoundingClientRect(),
        left = _range$getBoundingCli.left,
        top = _range$getBoundingCli.top;

    canvas.externalLinkPopover.summon({
      editableElement: _this.editableElement(),
      x: left,
      y: top,
      isEditing: true
    });
  }

  _this.hide();
};

this.link = function (e, newUrl) {
  e.stopPropagation();
  _this.closeSizeMenu();

  var selection = document.getSelection();
  var selectionLength = selection.toString().length;
  var range = selectionLength && selection.getRangeAt(0);

  var selectedNode = range.commonAncestorContainer;
  var selectedElement = selectedNode.nodeType == 1 ? selectedNode : selectedNode.parentElement;

  var containingATag = selectedElement.closest('[contenteditable] a');

  var alreadyExistingUrl = '';

  if (containingATag) {
    range.selectNode(containingATag);
    alreadyExistingUrl = containingATag.getAttribute('href');
  }

  _this.isEditingLink = true;

  _this.update();
};

this.linkChangeHandler = function (url, aTag) {
  if (url) {
    if (!url.match(/^(http|https):\/\//i)) {
      url = 'http://' + url;
    }

    if (!aTag) {
      restoreSelection(_this.lastSelectionRange);
      document.execCommand('createLink', false, url);
    } else if (aTag && aTag.href !== url) {
      aTag.setAttribute('href', url);
    }
  } else {
    if (!aTag) {
      restoreSelection(_this.lastSelectionRange);
      document.execCommand('unlink');
    } else {
      _this.removeLink(aTag);
    }
    _this.isLink = false;
  }

  _this.hide();
};

this.removeLink = function (aTag) {
  var selection = window.getSelection();
  var range = document.createRange();

  range.selectNodeContents(aTag);
  selection.removeAllRanges();
  selection.addRange(range);

  document.execCommand('unlink');

  selection.removeAllRanges();

  _this.hide();
};

this.underline = function (e) {
  e.stopPropagation();
  _this.closeSizeMenu();
  document.execCommand('underline');

  _this.toolbarUsed = true;
  _this.toggle();
};

this.italics = function (e) {
  e.stopPropagation();
  _this.closeSizeMenu();
  document.execCommand('italic');

  _this.toolbarUsed = true;
  _this.toggle();
};

this.preventDefault = function (e) {
  e.preventDefault();
  e.stopPropagation();
};

this.getSnugRange = function (range) {

  // firefox likes to start just shy of where one might think it would be reasonable
  // and end just past. this says if we're starting at the very end of a text node,
  // past the end of its contents, let's start at the beginning of the following node
  // instead, and opposite-similarly at the other end of the range

  if (!range) return;
  var snug = range.cloneRange();

  if (range.startContainer && range.startContainer.nodeType == 3 && range.startOffset == range.startContainer.length && range.startContainer.nextSibling) {

    snug.setStart(range.startContainer.nextSibling, 0);
  }

  if (range.endContainer && range.endContainer.nodeType == 3 && range.endOffset == 0 && range.endContainer.previousSibling) {
    var previousSibling = range.endContainer.previousSibling;

    var endOffset = previousSibling.nodeType == 1 ? previousSibling.childNodes.length : previousSibling.textContent.length;
    snug.setEnd(range.endContainer.previousSibling, endOffset);
  }

  return snug;
};

this.toggle = function () {
  _this.isBold = false;
  _this.isUnderline = false;
  _this.isItalics = false;
  _this.activeSize = 'normal';

  var selection = document.getSelection();
  var selectionLength = selection.toString().length;
  var range = selectionLength && selection.getRangeAt(0);

  var snugRange = range && _this.getSnugRange(range);

  if (!selectionLength && _this.summoned) {
    _this.hide();
    return;
  }

  if (!_this.editableElement()) return;

  if (!_this.toolbarUsed) {
    if (selectionLength && !_this.summoned) {
      var commonAC = snugRange.commonAncestorContainer;

      var parentRects = void 0;
      if (commonAC.classList && (commonAC.classList.contains('title') || commonAC.classList.contains('summary'))) {
        parentRects = commonAC.closest('.title, .summary').getBoundingClientRect();
      } else {
        parentRects = commonAC.parentElement.closest('.title, .summary').getBoundingClientRect();
      }

      _this.summon({
        x: parentRects.left - 3,
        y: parentRects.top - 50
      });
    }
  }

  canvas.externalLinkPopover.hide();

  var selectedNode = snugRange.commonAncestorContainer;
  if (!selectedNode) return;

  var selectedElement = selectedNode.nodeType == 1 ? selectedNode : selectedNode.parentElement;

  var styles = {};
  var computedStyle = window.getComputedStyle(selectedElement);

  var editableElement = _this.editableElement();
  var editableComputedStyle = window.getComputedStyle(editableElement);
  var baseFontSize = parseInt(editableComputedStyle.getPropertyValue('font-size'));

  if (computedStyle.getPropertyValue('font-weight') >= 700) {
    styles.isBold = true;
  }
  if (parseInt(computedStyle.getPropertyValue('font-size')) >= baseFontSize * 1.2) {
    styles.activeSize = 'large';
  }
  if (parseInt(computedStyle.getPropertyValue('font-size')) >= baseFontSize * 1.4) {
    styles.activeSize = 'huge';
  }
  if (computedStyle.getPropertyValue('text-decoration').includes('underline')) {
    styles.isUnderline = true;
  }
  if (computedStyle.getPropertyValue('font-style').includes('italic')) {
    styles.isItalics = true;
  }
  if (selectedElement.closest('[contenteditable] a')) {
    styles.isLink = true;
  }

  _this.update(styles);
};

$(this.canvas.refs.canvas).on('panzoomzoom panzoompan', (0, _lodash2.default)(function (e) {
  if (!_this.summoned) {
    _this.toggle();
  }
}, 400));

this.toggleSizeMenu = function (e) {
  e.stopPropagation();
  var sizeMenu = _this.refs.sizeMenu;

  sizeMenu.classList.toggle('floating-menu--hidden');
};

this.closeSizeMenu = function () {
  var sizeMenu = _this.refs.sizeMenu;

  _this.isSizeMenuOpen = false;
  sizeMenu.classList.toggle('floating-menu--hidden', true);
};

this.openSizeMenu = function () {
  var sizeMenu = _this.refs.sizeMenu;

  _this.isSizeMenuOpen = true;
  sizeMenu.classList.toggle('floating-menu--hidden', false);
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('text-toolbar')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/text-toolbar.html
// module id = 745
// module chunks = 0